module.exports = __webpack_public_path__ + "img/BiziClickPortal.ad34e5a4.png";